<template>
    <multiselect :disabled="this.disabled" :readonly="this.disabled" :allowEmpty="this.allowEmpty"
        @search-change="handleSearch" :label="this.label ? this.label : 'name'"
        :track-by="this.trackBy ? this.trackBy : 'name'" :loading="this.loading"
        :options="(this.optionsData.length > 0) ? this.optionsData : (this.options != undefined ? this.options : [])"
        v-model="selected" :placeholder="placeholder ? placeholder : `type to search`" />
</template>
<script>

export default {
    components: {
    },
    props: {
        multiple: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String
        },
        label: {
            type: String,
        },
        baseUrl: {
            type: String,
        },
        allowEmpty: {
            type: Boolean,
            default: true,
        },
        trackBy: {
            type: String,
        },
        value: {
            type: Object,
        },
        id: {
            default: 0,
        },
        warehouse_id: {
            default: 0,
        },
        warehouse_area_id: {
            default: 0,
        },
        options: {
            required: false
        }
    },
    data() {
        return {
            // baseUrl: "/api/wms/v1/master/warehouses",
            typedValue: "",
            timeOuts: null,
            optionsData: [],
            loading: false,
            selected: this.value ? this.value : {}
        };
    },
    methods: {
        handleSearch(v) {
            this.typedValue = v;
            if (this.timeOuts) { clearTimeout(this.timeOuts) }
            this.timeOuts = setTimeout(this.get, 400);
        },
        get() {
            this.loading = true;
            this.$http
                .get(this.baseUrl, {
                    params: {
                        order: "id",
                        sort: "asc",
                        query: this.typedValue,
                        id: this.id,
                        warehouse_id: this.warehouse_id,
                        warehouse_area_id: this.warehouse_area_id,
                    }
                })
                .then(resp => {
                    if (resp.code == 200) {
                        if (resp.data.records) {
                            this.optionsData = resp.data.records;
                            resp.data.records.forEach((v, i) => {
                                if (v.code && v.name) {
                                    this.optionsData[i].name = `${v.code} - ${v.name}`
                                }
                            });
                            if (!this.value && resp.data.default) {
                                this.selected = resp.data.default;
                                this.$emit("selected", resp.data.default);
                            }
                        }
                    } else {
                        this.optionsData = [];
                        console.log(resp.data);
                    }
                });
            this.loading = false;
        }

    },
    watch: {
        selected(v) {
            this.selected = v;
            this.$emit("selected", v);
        },
        value(v) {
            if (v) {
                this.selected = v
            }
        }
    },
    mounted() {
        if (this.baseUrl != "" && this.baseUrl != undefined) {
            this.get();
        } else if (this.options.length > 0) {
            this.optionsData = this.options
        }
    }
};
</script>
<style>
.multiselect--above .multiselect__content-wrapper {
    bottom: auto !important;
    top: 100% !important;
}
</style>